import { FIELD_STATUS_VALUES } from 'business/constants';
import type { LifeCycleStatus } from 'business/types';
import { addDays, format, startOfDay } from 'date-fns';
import type { Dispatch, SetStateAction } from 'react';

const DEFAULT_EXPIRATION_DELAY = 30;
const DATE_STRING_FORMAT = 'yyyy-MM-dd';
const { NEW } = FIELD_STATUS_VALUES;

const getDefaultExpirationDate = (): string =>
    format(
        addDays(startOfDay(new Date()), DEFAULT_EXPIRATION_DELAY),
        DATE_STRING_FORMAT,
    );

export const updateEndDate = (
    setEndDate: Dispatch<SetStateAction<string | undefined>>,
    newValue: Date | null,
): void => {
    setEndDate(newValue ? format(newValue, DATE_STRING_FORMAT) : undefined);
};

export const handleStatusEffectOnDate = (
    setEndDate: Dispatch<SetStateAction<string | undefined>>,
    newStatus: LifeCycleStatus,
    initialStatus: LifeCycleStatus,
    endDate: string | undefined,
    initialEndDate: string | undefined,
): void => {
    if (newStatus === NEW) {
        if (initialStatus !== NEW) {
            setEndDate(endDate ?? getDefaultExpirationDate());
        } else {
            setEndDate(endDate ?? initialEndDate ?? getDefaultExpirationDate());
        }
    } else {
        setEndDate(initialEndDate);
    }
};
